export const labels = {
	back: {
		label: "Label.MobileCreator.BottomMenu.Back",
		default: "Back",
	},
} as const;
